import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProgramData } from '@core/interfaces/analytics.interface';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
} from 'ng-apexcharts';

@Component({
  selector: 'app-events-table',
  template: `
    <div *ngIf="hasData; else noData">
      <apx-chart
        [series]="series"
        [chart]="chart"
        [xaxis]="xaxis"
        [yaxis]="yaxis"
        [plotOptions]="plotOptions"
        [dataLabels]="dataLabels"
        [tooltip]="tooltip"
        [colors]="colors"
      ></apx-chart>
    </div>
    <ng-template #noData>
      <div class="no-data-msg">
        <i class="ri-trophy-line"></i>
        <span>Sin datos de programas</span>
      </div>
    </ng-template>
  `,
  styles: [
    `
      .no-data-msg {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 300px;
        color: #ccc;
        gap: 10px;
      }
      .no-data-msg i {
        font-size: 48px;
      }
      .no-data-msg span {
        font-size: 14px;
      }
    `,
  ],
})
export class EventsTableComponent implements OnChanges {
  @Input() programData: ProgramData[] = [];

  hasData = false;
  series: ApexAxisChartSeries = [];
  colors = ['#f59e0b'];

  chart: ApexChart = {
    type: 'bar',
    height: 330,
    toolbar: { show: false },
    fontFamily: 'inherit',
  };

  plotOptions: ApexPlotOptions = {
    bar: { horizontal: true, barHeight: '60%', borderRadius: 4 },
  };

  dataLabels: ApexDataLabels = {
    enabled: true,
    formatter: (val: number) => val.toLocaleString('es'),
    style: { fontSize: '11px', colors: ['#fff'] },
  };

  tooltip: ApexTooltip = {
    y: { formatter: (val: number) => val.toLocaleString('es') + ' mensajes' },
  };

  xaxis: ApexXAxis = {
    categories: [],
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { fontSize: '11px' } },
  };

  yaxis: ApexYAxis = {
    labels: { style: { fontSize: '11px' } },
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['programData']?.currentValue) {
      const data = [...this.programData].slice(0, 10).reverse();
      const trim = (s: string) => (s?.length > 35 ? s.slice(0, 35) + '…' : s);
      this.xaxis = {
        categories: data.map((p) => trim(p.name)),
        axisBorder: { show: false },
        axisTicks: { show: false },
        labels: { style: { fontSize: '11px' } },
      };
      this.series = [{ name: 'Mensajes', data: data.map((p) => p.count) }];
      this.hasData = data.length > 0;
    }
  }
}
